module.exports = __webpack_public_path__ + "static/media/aaa.cc5d36e4.png";